import React, { FC } from 'react';
import _find from 'lodash/find';
import FormikSimpleCheckbox from '@minecraft.formik-simple-checkbox';
import CheckboxListWithSearch from '@minecraft.checkbox-list-with-search';
import { useDrawerSearchFilterNameOrCategory, useDrawerFiltersCounts } from '@minecraft.drawer';
import { FilterData, WillingToEnum } from '../../../shared/types';
import { Label } from '../../../shared/styles';
import { FiltersCategoryNameEnum, FiltersCountNameEnum } from '../../shared/types';

type Props = {
  willingToChange: FilterData;
  hairColor: FilterData;
};

const HairColor: FC<Props> = ({ willingToChange, hairColor }) => {
  const { isSearching, shouldCategoryFilterBeVisible, getMatchedSearchOptions } = useDrawerSearchFilterNameOrCategory(
    FiltersCategoryNameEnum.hairColor
  );
  const { filtersCounts } = useDrawerFiltersCounts();

  const willingToChangeCount =
    _find(filtersCounts?.[FiltersCountNameEnum.willingnessIds], {
      key: WillingToEnum.hairColor,
    })?.docCount || 0;

  return (
    <>
      {isSearching && <Label>{hairColor.label}</Label>}
      {shouldCategoryFilterBeVisible(willingToChange.name) && (
        <FormikSimpleCheckbox name={willingToChange.name} label={willingToChange.label} count={willingToChangeCount} />
      )}
      {shouldCategoryFilterBeVisible(hairColor.name) && (
        <CheckboxListWithSearch
          withFormik
          withSelectAll
          name={hairColor.name}
          options={getMatchedSearchOptions(hairColor.name)}
        />
      )}
    </>
  );
};

export default HairColor;
